package com.dotpx.ambient

enum class AmbienceVisualSound(val affectsExistingParticlesOnly: Boolean = false) {
    Wind,
    Rain,
    Surf,
    Forest,
    Fire,
    Water,
    Train,
    Steam,
    Room,
    Drone,
    ToneLow,
    ToneMid,
    ToneHigh,
    Bird,
    InsectCall,
    Drip(true),
    Bell,
    Metal(true),
    Creak,
    Spark,
    Relay,
    Frog,
    Thunder,
    Radio,
    TrainJoint,
    Beep(true),
    Rock,
    WaveSlap,
    Higurashi,
    Dove,
    Brook,
    Waterfall,
    Blizzard,
    Ventilation,
    DistantTraffic,
    BoatEngine,
    WindChime,
    Owl,
    Cricket,
    Bubble,
    FootstepGravel,
    FootstepSnow,
    BranchSnap,
    ClockTick,
    BuoyBell,
    BrownNoise,
    LeafDrip,
    BicyclePass,
    ;

    /** One-shot voices use expanding ripples in the light appearance. */
    val isTransient: Boolean
        get() = when (this) {
            Bird, InsectCall, Drip, Bell, Metal, Creak, Spark, Relay, Frog,
            Thunder, Radio, TrainJoint, Beep, Rock, WaveSlap, Higurashi, Dove,
            WindChime, Owl, Cricket, Bubble, FootstepGravel, FootstepSnow,
            BranchSnap, ClockTick, BuoyBell, LeafDrip, BicyclePass -> true
            else -> false
        }
}

internal val TextureKind.visualSound: AmbienceVisualSound
    get() = when (this) {
        TextureKind.Wind -> AmbienceVisualSound.Wind
        TextureKind.Rain -> AmbienceVisualSound.Rain
        TextureKind.Surf -> AmbienceVisualSound.Surf
        TextureKind.Forest -> AmbienceVisualSound.Forest
        TextureKind.Fire -> AmbienceVisualSound.Fire
        TextureKind.Water -> AmbienceVisualSound.Water
        TextureKind.Train -> AmbienceVisualSound.Train
        TextureKind.Steam -> AmbienceVisualSound.Steam
        TextureKind.Room -> AmbienceVisualSound.Room
        TextureKind.Brook -> AmbienceVisualSound.Brook
        TextureKind.Waterfall -> AmbienceVisualSound.Waterfall
        TextureKind.Blizzard -> AmbienceVisualSound.Blizzard
        TextureKind.Ventilation -> AmbienceVisualSound.Ventilation
        TextureKind.DistantTraffic -> AmbienceVisualSound.DistantTraffic
        TextureKind.BoatEngine -> AmbienceVisualSound.BoatEngine
        TextureKind.BrownNoise -> AmbienceVisualSound.BrownNoise
    }

internal val EventKind.visualSound: AmbienceVisualSound
    get() = when (this) {
        EventKind.None -> AmbienceVisualSound.Room
        EventKind.Bird -> AmbienceVisualSound.Bird
        EventKind.InsectCall -> AmbienceVisualSound.InsectCall
        EventKind.Drip -> AmbienceVisualSound.Drip
        EventKind.Bell -> AmbienceVisualSound.Bell
        EventKind.Metal -> AmbienceVisualSound.Metal
        EventKind.Creak -> AmbienceVisualSound.Creak
        EventKind.Spark -> AmbienceVisualSound.Spark
        EventKind.Relay -> AmbienceVisualSound.Relay
        EventKind.Frog -> AmbienceVisualSound.Frog
        EventKind.Thunder -> AmbienceVisualSound.Thunder
        EventKind.Radio -> AmbienceVisualSound.Radio
        EventKind.TrainJoint -> AmbienceVisualSound.TrainJoint
        EventKind.Beep -> AmbienceVisualSound.Beep
        EventKind.Rock -> AmbienceVisualSound.Rock
        EventKind.WaveSlap -> AmbienceVisualSound.WaveSlap
        EventKind.Higurashi -> AmbienceVisualSound.Higurashi
        EventKind.Dove -> AmbienceVisualSound.Dove
        EventKind.WindChime -> AmbienceVisualSound.WindChime
        EventKind.Owl -> AmbienceVisualSound.Owl
        EventKind.Cricket -> AmbienceVisualSound.Cricket
        EventKind.Bubble -> AmbienceVisualSound.Bubble
        EventKind.FootstepGravel -> AmbienceVisualSound.FootstepGravel
        EventKind.FootstepSnow -> AmbienceVisualSound.FootstepSnow
        EventKind.BranchSnap -> AmbienceVisualSound.BranchSnap
        EventKind.ClockTick -> AmbienceVisualSound.ClockTick
        EventKind.BuoyBell -> AmbienceVisualSound.BuoyBell
        EventKind.LeafDrip -> AmbienceVisualSound.LeafDrip
        EventKind.BicyclePass -> AmbienceVisualSound.BicyclePass
    }
